import { Info } from 'lucide-react';

export default function ModalSignMessageContent({
  connectorName,
}: {
  connectorName: string;
}) {
  return (
    <div className="relative bg-card min-w-68 p-6 pb-8 flex flex-col items-center max-md:w-full max-md:min-w-0 max-md:justify-center">
      <div className="pt-22 relative">
        <Info className="absolute top-0 left-1/2 -translate-x-1/2 w-18 h-18 text-primary" />
        <h2 className="text-xl font-bold text-foreground">Sign In</h2>
      </div>
      <p className="text-muted-foreground text-center mt-3 text-sm">
        Sign message in {connectorName}
      </p>
    </div>
  );
}
